export default "__VITE_ASSET__f7c41dfa__"